import type { ReactElement } from "react";
import { Input } from "../../../../shared/components/ui/input";

interface URLInputFieldProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onClearError: () => void;
}

/**
 * URL Input Field Component
 */
export function URLInputField({ value, onChange, onSubmit, onClearError }: Readonly<URLInputFieldProps>): ReactElement {
  return (
    <div className="flex gap-2">
      <Input
        type="url"
        placeholder="https://example.com/image.jpg"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          onClearError();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
          }
        }}
      />
      <button
        onClick={onSubmit}
        disabled={!value.trim()}
        className="btn-admin-action disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        +
      </button>
    </div>
  );
}
